import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CreditDTO } from '../../../../../shared/credit-dto';
import { CustomerService } from '../../customer.service';
import { AccountService } from '../../account.service';
import { AccountDTO } from '../../../../../shared/account-dto';

@Component({
  selector: 'pv-credits',
  templateUrl: './credits.component.html',
  styleUrls: ['./credits.component.scss']
})
export class CreditsComponent implements OnInit {
  @Input() checkout: boolean;
  @Output() onRedeem: EventEmitter<void> = new EventEmitter<void>();
  creditCode: string;
  credits: CreditDTO[] = []
  show = false;
  errorMessage: string;
  account: AccountDTO = { } as AccountDTO

  constructor(
    private customerService: CustomerService,
    private datePipe: DatePipe,
    private accountService: AccountService
  ) { }

  ngOnInit() {
    // Subscribe to account
    this.account = this.accountService.account
    this.accountService.accountSubject
    .subscribe(account => this.account = account)

    this.credits = this.customerService.checkoutDTO.customer.credits
    this.customerService.checkoutSubject
    .subscribe(checkoutDTO => this.credits = (checkoutDTO.customer.credits || []).sort((a, b) => b.amount - a.amount))

    this.customerService.updateCredits()
  }

  totalCredit() {
    return this.credits ? this.credits.reduce((total, credit) => this.isExpired(credit) ? total : credit.amount + total, 0) : 0
  }

  redeem() {
    this.errorMessage = null
    this.customerService.redeemCredits(this.creditCode)
    .subscribe(creditDTO => {
      this.customerService.updateCheckoutDTO({
        customer: {
          ...this.customerService.checkoutDTO.customer,
          credits: (this.customerService.checkoutDTO.customer.credits || []).concat([creditDTO]).filter((credit, index, arr) => arr.indexOf(arr.find(c => c.id == credit.id)) == index) },
        useCredits: true
      })
      this.customerService.updateCredits()
      this.onRedeem.emit();
    }, err => {
      if (err && err.error && err.error.message && err.error.message.message) {
        this.errorMessage = err.error.message.message
      } else if (err && err.error && err.error.message) {
        this.errorMessage = err.error.message
      } else if (err && err.error) {
        this.errorMessage = JSON.stringify(err.error)
      } else if (err) {
        this.errorMessage = JSON.stringify(err)
      }
    })
  }

  isExpired(credit: CreditDTO) {
    if (credit.expire_datetime && new Date(credit.expire_datetime) < new Date()) {
      return true
    } else if (credit.amount <= 0) {
      return true
    } else {
      return false
    }
  }
}
